import * as React from 'react'

const IconInfo = (props) => {
  const { color } = props
  return (
    <svg width={24} height={24} xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='none' fillRule='evenodd'>
        <circle stroke={color || '#00B2E3'} strokeWidth={3} cx={12} cy={12} r={10.5} />
        <circle fill={color || '#00B2E3'} cx={12} cy={7} r={2} />
        <rect fill={color || '#00B2E3'} x={10} y={10} width={4} height={9} rx={1} />
      </g>
    </svg>
  )
}

export default IconInfo
